import env from './env'
import getCountryConfig from '@/config/countryConfig/index'
import I18nUtil from '@didi/i18n-util'
import sim from '@/utils/sim'
import { getCountry } from '@/utils/getLocalStorageCountry'
import { isH5 } from '@/utils/tools'
const { getLanguageLong } = I18nUtil
const getLanguage = getLanguageLong() === 'es-419' ? 'es-MX' : getLanguageLong()

const configuration = {
  pre: {
    cApi: 'https://pre-c.didi-food.com',
    actApi: 'https://pre-act-api.didi-food.com',
    cashierApi: 'https://cashier-pre.didiglobal.com',
    payApi: 'https://pay-pre.didiglobal.com',
    adsApi: 'https://ads.didiglobal.com',
    h5LoginUrl: '//static.didiglobal.com/h5-login-global/2.5.3/login.global.min.js',
    passportUrl: 'https://page.didiglobal.com/public-biz/pc-login/3.0.8/index.html',
  },
  sim: {
    // cApi: 'https://rlab-sim060-soda-c-api.rlab.sim.intra.xiaojukeji.com',
    // actApi: 'https://rlab-sim060-soda_c_act_api.rlab.sim.intra.xiaojukeji.com',

    cApi: sim.getSimCApi(),
    actApi: sim.getSimActApi(),
    cashierApi: sim.getSimCashierApi(),
    payApi: sim.getSimPayApi(),
    adsApi: sim.getSimAdsApi(),
    h5LoginUrl: '//static.didiglobal.com/h5-login-global/2.5.3/login.global.min.js',
    passportUrl: 'https://page.didiglobal.com/public-biz/pc-login/3.0.8/index.html',
  },
  dev: {
    cApi: '/DEV_PROXY_C_API',
    actApi: '/DEV_PROXY_ACT_API',
    cashierApi: '/DEV_PROXY_CASHIER_API',
    // payApi: '',
    // cApi: sim.getSimCApi(),
    // actApi: sim.getSimActApi(),
    // cashierApi: sim.getSimCashierApi(),
    payApi: sim.getSimPayApi(),
    adsApi: '/DEV_PROXY_ADS_API',
    h5LoginUrl: '//static.didiglobal.com/h5-login-global/2.5.3/login.global.min.js',
    // '//passport-test.didichuxing.com/static/trinity-login/2.0.7/login.test.js',
    passportUrl: 'https://page.didiglobal.com/public-biz/pc-login/3.0.8/index.html',
  },
}

let currentConfiguration

if (env.isSIM) {
  currentConfiguration = configuration.sim
} else if (env.isPre) {
  currentConfiguration = configuration.pre
} else {
  currentConfiguration = configuration.dev
}

const cApiBase = currentConfiguration.cApi

const config = {
  omega: {
    uploadHost: 'omgup.didiglobal.com',
    appKey: 'devOmegaKey', // 测试环境不上报数据
    browserRouterEnable: true,
    autoPosition: false,
  },

  cApiBase,
  actApiBase: currentConfiguration.actApi,
  cashierApiBase: currentConfiguration.cashierApi,
  adsApiBase: currentConfiguration.adsApi,
  passport: {
    h5LoginUrl: currentConfiguration.h5LoginUrl,
    passportUrl: currentConfiguration.passportUrl,

    setCookieUrl: `${cApiBase}/login/callback`,
    appId: isH5() ? 200011 : getCountryConfig.login.appIdPC(getCountry),
    source: 70001, // 根据国家区分
    role: 1,
    lang: getLanguage,
    law_url: getCountryConfig.login.lawUrlH5(getCountry),
    country_id: getCountryConfig.login.countryId(getCountry),
    country_calling_code: getCountryConfig.login.countryCallingCode(getCountry),
    city_id: 0,
    canonical_country_code: getCountryConfig.login.canonicalCountryCode(getCountry),
    // eslint-disable-next-line no-void
    theme: env.is99 ? 'yellow' : void 0,
    extra_info: isH5() ? { channel: 'google_map' } : '',
  },
}

export default config
